import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 30px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1862.8 1393.1">
    <defs>
      <clipPath id="j">
        <path d="M1451.7 714.88h-211.92v7.697h211.92z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1239.8 718.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="i">
        <path d="M1451.7 277.92h-211.92v7.696h211.92z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1239.8 281.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="h">
        <path d="M197.96 544.77h-88.752l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 153.12 544.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="n">
        <path d="M197.96 474.11h-88.752l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 153.12 474.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="m">
        <path d="M197.96 405.33h-88.752l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 153.12 405.33)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="l">
        <path d="M197.96 334.89h-88.752l-5.535 98.899h98.9z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 153.12 334.89)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="k">
        <path d="M934.75 724.96H556.87v212.56h377.88z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="scale(378.6 -378.6) rotate(33.01 4.918 1.452)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
    </defs>
    <path
      fill="#e5e4e3"
      d="M0 0h-487.63l-247.02-336H245.6z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(990.34 595.96)"
    />
    <path
      fill="#d8d7d6"
      d="M1235.6 229.35H256.06v30.61h979.54z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M1445.8 284.88h-200v430h200z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <g
      clipPath="url(#j)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path fill="url(#b)" d="M1451.7 714.88h-211.92v7.697h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1240.2 711.18h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#515050"
      d="M1455.6 711.18h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <g
      clipPath="url(#i)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path fill="url(#a)" d="M1451.7 277.92h-211.92v7.696h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1240.2 274.23h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#515050"
      d="M1455.6 274.23h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#404041"
      d="M0 0h-158.63l14.76 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(232.71 279.41)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-111.58l-9.226 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(209.64 279.41)"
    />
    <g
      clipPath="url(#h)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path
        fill="url(#g)"
        d="M197.96 544.77h-88.752l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path
        fill="url(#f)"
        d="M197.96 474.11h-88.752l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path
        fill="url(#e)"
        d="M197.96 405.33h-88.752l-5.535 98.9h98.9z"
      />
    </g>
    <g
      clipPath="url(#l)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path
        fill="url(#d)"
        d="M197.96 334.89h-88.752l-5.535 98.899h98.9z"
      />
    </g>
    <path
      fill="#404041"
      d="M247.81 272.23H58.44v14.367h189.37z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#eaeaea"
      d="M0 0l-180.5-16h-291L-669 0v-710l197.5 20h291L0-710z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(1080.3 1182.6)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M891.31 1166.6h-291v-674h291z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l-190-17v40L0 40z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(600.81 585.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l-190 12v40L0 40z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(600.81 989.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l190-17v40L0 40z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(890.81 585.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l190 12v40L0 40z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(890.81 989.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M813.81 564.64h-136v-259h136z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#d8d7d6"
      d="M0 0l-114-11v-259L0-259z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(927.81 575.64)"
    />
    <path
      fill="#d8d7d6"
      d="M0 0l114-11v-259L0-259z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(563.81 575.64)"
    />
    <path
      fill="#e5e4e3"
      d="M0 0l34.873 12h290l39-12-115-11h-135z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(563.94 575.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l-115 12v18L0 18z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(678.81 513.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l-115 12v18L0 18z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(678.81 338.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l115 12v18L0 18z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(812.81 513.64)"
    />
    <path
      fill={themeColor || '#db4c35'}
      d="M0 0l115 12v18L0 18z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9) translate(812.81 338.64)"
    />
    <g
      clipPath="url(#k)"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    >
      <path fill="url(#c)" d="M934.75 724.96H556.87v212.56h377.88z" />
    </g>
    <path
      fill="none"
      stroke="#59595c"
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M934.75 724.96H556.87v212.56h377.88z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
    <path
      fill="#fff"
      stroke={themeColor || '#cc4032'}
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M1037.7 1057.1H453.96v213.56h583.74z"
      transform="matrix(1.3333 0 0 -1.3333 -77.916 1698.9)"
    />
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
